import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output, } from '@angular/core';
import { CoreService } from '../../store/core.service';
import { PermissionsType } from '../../../user/permissions/permissions.datamodel';
import { Subscription } from 'rxjs';
import { LSSEntityObject } from '../../../shared/list/lssEntity.datamodel';
import { AppService } from '../../../application/app.service';
import { PipesModule } from '../../../shared/pipes/pipes.module';
import { SearchComponent } from '../../../shared/search/search.component';


/**
 * Component representing the Navigation bar of App Store.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "ama-ng-navbar",
  standalone: true,
  imports: [
    PipesModule,
    SearchComponent
],
  templateUrl: "./navbar.component.html"
})
export class NavBarComponent implements OnInit, OnDestroy {
  @Input() numberNewApps!: number;
  @Input() section!: string;
  @Input() idSuffix!: string;
  @Output() menuItemSelected: EventEmitter<void> = new EventEmitter();
  entity: LSSEntityObject = {label: ''};
  subscription: Subscription = new Subscription();
  protected readonly PermissionsType = PermissionsType;

  constructor(private readonly coreService: CoreService, private readonly appService: AppService) {
  }

  ngOnInit() {
    this.subscription.add(
      this.appService.entitySelected$.subscribe(entity => {
        this.entity = entity;
      }
    ));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  /**
   * Handle click
   * @param event
   * @param target
   */
  handleClickTabs(event: Event, target: string) {
    event.stopPropagation();
    this.menuItemSelected.emit();
    this.navigateTo(target);
  }

  /**
   * Navigate to a new section.
   */
  navigateTo = (destination: string) => this.coreService.navigateTo(destination);

  /**
   * A search has been launched
   */
  onSearch = () => this.menuItemSelected.emit();
}
